export const SET_GLOBAL_THEME = 'SET_GLOBAL_THEME';

// Hardcoded to light
export const setGlobalTheme = (name) => ({
	type: SET_GLOBAL_THEME,
	name,
});
